import { LogOut, MoveUpRight } from 'lucide-react';
import errorIllustration from '../../assets/images/exclamation-mark.png';
import { Button } from '../../design-system/button/button';
import { Stack } from '../../design-system/stack/stack';

export const ReachoutPage = () => {
  return (
    <Stack space={4} align="center" className="mt-48">
      <Stack space={2} align="center">
        <div className="h-40 w-40">
          <img
            src={errorIllustration}
            alt=""
            loading="eager"
            fetchPriority="high"
            className="h-full w-full object-cover"
          />
        </div>

        <h2 className="text-center text-2xl font-medium">Thank you for your interest in Seapoint.</h2>

        <p className="text-center text-base font-medium text-seapoint-gray-text">
          Please join our waitlist to get access.
        </p>
      </Stack>

      <Button iconRight={<MoveUpRight />} onClick={() => (window.location.href = 'https://seapoint.co')}>
        Join the waitlist
      </Button>
      <Button iconRight={<LogOut />} onClick={() => (window.location.href = '/auth/logout')}>
        Log out
      </Button>
    </Stack>
  );
};
